import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const LOGO =
  "https://customer-assets-jai6qajn.emergentagent.net/job_elixz-occasions/artifacts/t6uoijzh_logo.png";

// Update this to your real WhatsApp number (with country code, no + or spaces)
export const WHATSAPP = "919945497442";
export const INSTAGRAM = "https://www.instagram.com/elixz.chocolates";

export const waLink = (msg) =>
  `https://wa.me/${WHATSAPP}?text=${encodeURIComponent(msg)}`;
